var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 7.33331C27.2136 7.33331 23.3334 11.2135 23.3334 16C23.3334 20.7864 27.2136 24.6666 32 24.6666C36.7865 24.6666 40.6667 20.7864 40.6667 16C40.6667 11.2135 36.7865 7.33331 32 7.33331ZM19.3334 16C19.3334 9.00437 25.0044 3.33331 32 3.33331C38.9956 3.33331 44.6667 9.00437 44.6667 16C44.6667 22.9956 38.9956 28.6666 32 28.6666C25.0044 28.6666 19.3334 22.9956 19.3334 16Z",
    fill: "#0E9658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 58.6667C6 44.3073 17.6406 32.6667 32 32.6667C46.3594 32.6667 58 44.3073 58 58.6667C58 59.7712 57.1046 60.6667 56 60.6667C54.8954 60.6667 54 59.7712 54 58.6667C54 46.5164 44.1502 36.6667 32 36.6667C19.8498 36.6667 10 46.5164 10 58.6667C10 59.7712 9.10457 60.6667 8 60.6667C6.89543 60.6667 6 59.7712 6 58.6667Z",
    fill: "#0E9658"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreen);
export default __webpack_public_path__ + "static/media/userGreen.bbfcd54b2287fd4a420887952fb3c891.svg";
export { ForwardRef as ReactComponent };